import Mr, { useState as Ar, useCallback as ct, useEffect as _r, createContext as pn, useContext as It, useMemo as ae, Fragment as Je } from "react";
import { useFormContext as Ur, useWatch as dn, useController as gn, useFieldArray as yn, FormProvider as hn } from "react-hook-form";
import { INTERNAL_CUSTOM_OPERATORS_ENUM as Oe, UTILITY_OPERATORS_ENUM as Lr, CUSTOM_OPERATORS_ENUM as ge, JSON_LOGIC_OPERATORS as Dt } from "@nirmata/shared";
const ot = "dfFieldId";
var Te = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var zr = { exports: {} }, $r = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tt;
function vn() {
  if (Tt) return $r;
  Tt = 1;
  var t = Mr, c = Symbol.for("react.element"), d = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(f, l, u) {
    var y, b = {}, m = null, F = null;
    u !== void 0 && (m = "" + u), l.key !== void 0 && (m = "" + l.key), l.ref !== void 0 && (F = l.ref);
    for (y in l) i.call(l, y) && !n.hasOwnProperty(y) && (b[y] = l[y]);
    if (f && f.defaultProps) for (y in l = f.defaultProps, l) b[y] === void 0 && (b[y] = l[y]);
    return { $$typeof: c, type: f, key: m, ref: F, props: b, _owner: v.current };
  }
  return $r.Fragment = d, $r.jsx = a, $r.jsxs = a, $r;
}
var Ir = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jt;
function _n() {
  return jt || (jt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Mr, c = Symbol.for("react.element"), d = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), f = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), F = Symbol.for("react.offscreen"), U = Symbol.iterator, R = "@@iterator";
    function T(r) {
      if (r === null || typeof r != "object")
        return null;
      var g = U && r[U] || r[R];
      return typeof g == "function" ? g : null;
    }
    var L = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(r) {
      {
        for (var g = arguments.length, S = new Array(g > 1 ? g - 1 : 0), j = 1; j < g; j++)
          S[j - 1] = arguments[j];
        k("error", r, S);
      }
    }
    function k(r, g, S) {
      {
        var j = L.ReactDebugCurrentFrame, D = j.getStackAddendum();
        D !== "" && (g += "%s", S = S.concat([D]));
        var x = S.map(function(I) {
          return String(I);
        });
        x.unshift("Warning: " + g), Function.prototype.apply.call(console[r], console, x);
      }
    }
    var Z = !1, je = !1, G = !1, Q = !1, ce = !1, ye;
    ye = Symbol.for("react.module.reference");
    function we(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === n || ce || r === v || r === u || r === y || Q || r === F || Z || je || G || typeof r == "object" && r !== null && (r.$$typeof === m || r.$$typeof === b || r.$$typeof === a || r.$$typeof === f || r.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === ye || r.getModuleId !== void 0));
    }
    function Ue(r, g, S) {
      var j = r.displayName;
      if (j)
        return j;
      var D = g.displayName || g.name || "";
      return D !== "" ? S + "(" + D + ")" : S;
    }
    function he(r) {
      return r.displayName || "Context";
    }
    function Y(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case d:
          return "Portal";
        case n:
          return "Profiler";
        case v:
          return "StrictMode";
        case u:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case f:
            var g = r;
            return he(g) + ".Consumer";
          case a:
            var S = r;
            return he(S._context) + ".Provider";
          case l:
            return Ue(r, r.render, "ForwardRef");
          case b:
            var j = r.displayName || null;
            return j !== null ? j : Y(r.type) || "Memo";
          case m: {
            var D = r, x = D._payload, I = D._init;
            try {
              return Y(I(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var fe = Object.assign, ve = 0, ie, qe, ze, Fe, Pe, $e, se;
    function Ie() {
    }
    Ie.__reactDisabledLog = !0;
    function fr() {
      {
        if (ve === 0) {
          ie = console.log, qe = console.info, ze = console.warn, Fe = console.error, Pe = console.group, $e = console.groupCollapsed, se = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Ie,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ve++;
      }
    }
    function N() {
      {
        if (ve--, ve === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: fe({}, r, {
              value: ie
            }),
            info: fe({}, r, {
              value: qe
            }),
            warn: fe({}, r, {
              value: ze
            }),
            error: fe({}, r, {
              value: Fe
            }),
            group: fe({}, r, {
              value: Pe
            }),
            groupCollapsed: fe({}, r, {
              value: $e
            }),
            groupEnd: fe({}, r, {
              value: se
            })
          });
        }
        ve < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = L.ReactCurrentDispatcher, ke;
    function H(r, g, S) {
      {
        if (ke === void 0)
          try {
            throw Error();
          } catch (D) {
            var j = D.stack.trim().match(/\n( *(at )?)/);
            ke = j && j[1] || "";
          }
        return `
` + ke + r;
      }
    }
    var Ne = !1, Ae;
    {
      var Ye = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Ye();
    }
    function le(r, g) {
      if (!r || Ne)
        return "";
      {
        var S = Ae.get(r);
        if (S !== void 0)
          return S;
      }
      var j;
      Ne = !0;
      var D = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = De.current, De.current = null, fr();
      try {
        if (g) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ne) {
              j = ne;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (ne) {
              j = ne;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            j = ne;
          }
          r();
        }
      } catch (ne) {
        if (ne && j && typeof ne.stack == "string") {
          for (var C = ne.stack.split(`
`), re = j.stack.split(`
`), W = C.length - 1, q = re.length - 1; W >= 1 && q >= 0 && C[W] !== re[q]; )
            q--;
          for (; W >= 1 && q >= 0; W--, q--)
            if (C[W] !== re[q]) {
              if (W !== 1 || q !== 1)
                do
                  if (W--, q--, q < 0 || C[W] !== re[q]) {
                    var K = `
` + C[W].replace(" at new ", " at ");
                    return r.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", r.displayName)), typeof r == "function" && Ae.set(r, K), K;
                  }
                while (W >= 1 && q >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, De.current = x, N(), Error.prepareStackTrace = D;
      }
      var or = r ? r.displayName || r.name : "", He = or ? H(or) : "";
      return typeof r == "function" && Ae.set(r, He), He;
    }
    function pe(r, g, S) {
      return le(r, !1);
    }
    function Re(r) {
      var g = r.prototype;
      return !!(g && g.isReactComponent);
    }
    function Le(r, g, S) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return le(r, Re(r));
      if (typeof r == "string")
        return H(r);
      switch (r) {
        case u:
          return H("Suspense");
        case y:
          return H("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            return pe(r.render);
          case b:
            return Le(r.type, g, S);
          case m: {
            var j = r, D = j._payload, x = j._init;
            try {
              return Le(x(D), g, S);
            } catch {
            }
          }
        }
      return "";
    }
    var ee = Object.prototype.hasOwnProperty, Ke = {}, Xe = L.ReactDebugCurrentFrame;
    function de(r) {
      if (r) {
        var g = r._owner, S = Le(r.type, r._source, g ? g.type : null);
        Xe.setExtraStackFrame(S);
      } else
        Xe.setExtraStackFrame(null);
    }
    function Ze(r, g, S, j, D) {
      {
        var x = Function.call.bind(ee);
        for (var I in r)
          if (x(r, I)) {
            var C = void 0;
            try {
              if (typeof r[I] != "function") {
                var re = Error((j || "React class") + ": " + S + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw re.name = "Invariant Violation", re;
              }
              C = r[I](g, I, j, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              C = W;
            }
            C && !(C instanceof Error) && (de(D), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", j || "React class", S, I, typeof C), de(null)), C instanceof Error && !(C.message in Ke) && (Ke[C.message] = !0, de(D), w("Failed %s type: %s", S, C.message), de(null));
          }
      }
    }
    var lr = Array.isArray;
    function Ge(r) {
      return lr(r);
    }
    function Qe(r) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, S = g && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return S;
      }
    }
    function pr(r) {
      try {
        return Ve(r), !1;
      } catch {
        return !0;
      }
    }
    function Ve(r) {
      return "" + r;
    }
    function er(r) {
      if (pr(r))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qe(r)), Ve(r);
    }
    var _e = L.ReactCurrentOwner, _ = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, P, M;
    function Me(r) {
      if (ee.call(r, "ref")) {
        var g = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function br(r) {
      if (ee.call(r, "key")) {
        var g = Object.getOwnPropertyDescriptor(r, "key").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function dr(r, g) {
      typeof r.ref == "string" && _e.current;
    }
    function Sr(r, g) {
      {
        var S = function() {
          P || (P = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        S.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function rr(r, g) {
      {
        var S = function() {
          M || (M = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        S.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var s = function(r, g, S, j, D, x, I) {
      var C = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: c,
        // Built-in properties that belong on the element
        type: r,
        key: g,
        ref: S,
        props: I,
        // Record the component responsible for creating this element.
        _owner: x
      };
      return C._store = {}, Object.defineProperty(C._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(C, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.defineProperty(C, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
    };
    function h(r, g, S, j, D) {
      {
        var x, I = {}, C = null, re = null;
        S !== void 0 && (er(S), C = "" + S), br(g) && (er(g.key), C = "" + g.key), Me(g) && (re = g.ref, dr(g, D));
        for (x in g)
          ee.call(g, x) && !_.hasOwnProperty(x) && (I[x] = g[x]);
        if (r && r.defaultProps) {
          var W = r.defaultProps;
          for (x in W)
            I[x] === void 0 && (I[x] = W[x]);
        }
        if (C || re) {
          var q = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          C && Sr(I, q), re && rr(I, q);
        }
        return s(r, C, re, D, j, _e.current, I);
      }
    }
    var O = L.ReactCurrentOwner, $ = L.ReactDebugCurrentFrame;
    function ue(r) {
      if (r) {
        var g = r._owner, S = Le(r.type, r._source, g ? g.type : null);
        $.setExtraStackFrame(S);
      } else
        $.setExtraStackFrame(null);
    }
    var Ce;
    Ce = !1;
    function tr(r) {
      return typeof r == "object" && r !== null && r.$$typeof === c;
    }
    function Er() {
      {
        if (O.current) {
          var r = Y(O.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function gr(r) {
      return "";
    }
    var Or = {};
    function Rr(r) {
      {
        var g = Er();
        if (!g) {
          var S = typeof r == "string" ? r : r.displayName || r.name;
          S && (g = `

Check the top-level render call using <` + S + ">.");
        }
        return g;
      }
    }
    function Tr(r, g) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var S = Rr(g);
        if (Or[S])
          return;
        Or[S] = !0;
        var j = "";
        r && r._owner && r._owner !== O.current && (j = " It was passed a child from " + Y(r._owner.type) + "."), ue(r), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, j), ue(null);
      }
    }
    function nr(r, g) {
      {
        if (typeof r != "object")
          return;
        if (Ge(r))
          for (var S = 0; S < r.length; S++) {
            var j = r[S];
            tr(j) && Tr(j, g);
          }
        else if (tr(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var D = T(r);
          if (typeof D == "function" && D !== r.entries)
            for (var x = D.call(r), I; !(I = x.next()).done; )
              tr(I.value) && Tr(I.value, g);
        }
      }
    }
    function Qr(r) {
      {
        var g = r.type;
        if (g == null || typeof g == "string")
          return;
        var S;
        if (typeof g == "function")
          S = g.propTypes;
        else if (typeof g == "object" && (g.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        g.$$typeof === b))
          S = g.propTypes;
        else
          return;
        if (S) {
          var j = Y(g);
          Ze(S, r.props, "prop", j, r);
        } else if (g.PropTypes !== void 0 && !Ce) {
          Ce = !0;
          var D = Y(g);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", D || "Unknown");
        }
        typeof g.getDefaultProps == "function" && !g.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function et(r) {
      {
        for (var g = Object.keys(r.props), S = 0; S < g.length; S++) {
          var j = g[S];
          if (j !== "children" && j !== "key") {
            ue(r), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", j), ue(null);
            break;
          }
        }
        r.ref !== null && (ue(r), w("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    var kr = {};
    function Gr(r, g, S, j, D, x) {
      {
        var I = we(r);
        if (!I) {
          var C = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (C += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var re = gr();
          re ? C += re : C += Er();
          var W;
          r === null ? W = "null" : Ge(r) ? W = "array" : r !== void 0 && r.$$typeof === c ? (W = "<" + (Y(r.type) || "Unknown") + " />", C = " Did you accidentally export a JSX literal instead of a component?") : W = typeof r, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, C);
        }
        var q = h(r, g, S, D, x);
        if (q == null)
          return q;
        if (I) {
          var K = g.children;
          if (K !== void 0)
            if (j)
              if (Ge(K)) {
                for (var or = 0; or < K.length; or++)
                  nr(K[or], r);
                Object.freeze && Object.freeze(K);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nr(K, r);
        }
        if (ee.call(g, "key")) {
          var He = Y(r), ne = Object.keys(g).filter(function(jr) {
            return jr !== "key";
          }), xr = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!kr[He + xr]) {
            var tt = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, xr, He, tt, He), kr[He + xr] = !0;
          }
        }
        return r === i ? et(q) : Qr(q), q;
      }
    }
    function rt(r, g, S) {
      return Gr(r, g, S, !0);
    }
    function Vr(r, g, S) {
      return Gr(r, g, S, !1);
    }
    var Cr = Vr, Be = rt;
    Ir.Fragment = i, Ir.jsx = Cr, Ir.jsxs = Be;
  }()), Ir;
}
var wt;
function mn() {
  return wt || (wt = 1, process.env.NODE_ENV === "production" ? zr.exports = vn() : zr.exports = _n()), zr.exports;
}
var B = mn();
const At = (t) => {
  let c;
  const d = /* @__PURE__ */ new Set(), i = (u, y) => {
    const b = typeof u == "function" ? u(c) : u;
    if (!Object.is(b, c)) {
      const m = c;
      c = y ?? (typeof b != "object" || b === null) ? b : Object.assign({}, c, b), d.forEach((F) => F(c, m));
    }
  }, v = () => c, f = { setState: i, getState: v, getInitialState: () => l, subscribe: (u) => (d.add(u), () => d.delete(u)) }, l = c = t(i, v, f);
  return f;
}, bn = (t) => t ? At(t) : At, Sn = (t) => t;
function En(t, c = Sn) {
  const d = Mr.useSyncExternalStore(
    t.subscribe,
    () => c(t.getState()),
    () => c(t.getInitialState())
  );
  return Mr.useDebugValue(d), d;
}
const Rt = (t) => {
  const c = bn(t), d = (i) => En(c, i);
  return Object.assign(d, c), d;
}, On = (t) => t ? Rt(t) : Rt, be = On((t) => ({
  propsSetters: {},
  validationsSetters: {},
  callbacks: {},
  dependencies: {},
  setFormState: (c) => t((d) => ({ ...d, ...c }))
})), Ct = (...t) => t.reduce((c, d) => [
  ...c.filter(
    (i) => !d.some(({ ruleType: v }) => v == i.ruleType)
  ),
  ...d
], []), Tn = (t) => t.includes("."), jn = (t, c) => {
  if (!t && !c) return !0;
  if (!t || !c || t.size !== c.size) return !1;
  for (const d of t)
    if (!c.has(d)) return !1;
  return !0;
}, wn = [
  ...Object.values(Oe),
  ...Object.values(Lr),
  ...Object.values(ge)
], at = (t) => Object.keys(t).some((c) => wn.includes(c)), it = (t) => Object.keys(t).some(
  (c) => [...Dt, ...Object.values(ge)].includes(
    c
  )
), vr = (t, c, d, i, v, n) => {
  const a = /* @__PURE__ */ new Set(), f = v && n !== void 0 ? `${v}.${n}.${c.fieldName}` : c.fieldName;
  return typeof t == "object" && t !== null && Object.entries(t).forEach(([l, u]) => {
    if (l === ge.valueOfField)
      Array.isArray(u) ? u.forEach((y) => {
        typeof y == "string" && y !== c.fieldName ? a.add(y) : typeof y == "object" && y !== null && (it(y) || at(y)) && vr(
          y,
          c,
          d,
          i,
          v,
          n
        ).forEach((m) => {
          m !== c.fieldName && a.add(m);
        });
      }) : typeof u == "object" && u !== null && (it(u) || at(u)) && vr(
        u,
        c,
        d,
        i,
        v,
        n
      ).forEach((b) => {
        b !== c.fieldName && a.add(b);
      });
    else if ([
      Oe.setFieldValue,
      Oe.setComponentProps,
      Oe.setFieldError,
      Oe.setFieldValidations
    ].includes(l))
      if (typeof u == "string" && u !== c.fieldName) {
        const y = u;
        d[y] || i((m) => ({
          ...m,
          [y]: /* @__PURE__ */ new Set()
        }));
        const b = d[y] || /* @__PURE__ */ new Set();
        b.has(f) || i((m) => ({
          ...m,
          [y]: /* @__PURE__ */ new Set([...b, f])
        }));
      } else typeof u == "object" && u !== null && vr(
        u,
        c,
        d,
        i,
        v,
        n
      ).forEach((b) => {
        b !== c.fieldName && a.add(b);
      });
    else l === "actions" && Array.isArray(u) ? u.forEach((y) => {
      typeof y == "object" && y !== null && vr(
        y,
        c,
        d,
        i,
        v,
        n
      ).forEach((m) => {
        m !== c.fieldName && a.add(m);
      });
    }) : typeof u == "object" && u !== null && (it(u) || at(u)) ? vr(
      u,
      c,
      d,
      i,
      v,
      n
    ).forEach((b) => {
      b !== c.fieldName && a.add(b);
    }) : typeof u == "object" && u !== null && vr(
      u,
      c,
      d,
      i,
      v,
      n
    ).forEach((b) => {
      b !== c.fieldName && a.add(b);
    });
  }), a;
}, An = (t) => {
  const [c, d] = Ar({}), { setFormState: i } = be(), v = ct(
    (n, a, f) => {
      const l = a && f !== void 0 ? `${a}.${f}.${n.fieldName}` : n.fieldName;
      if (c[l] || d((u) => ({
        ...u,
        [l]: /* @__PURE__ */ new Set()
      })), n.conditionalRules) {
        const u = /* @__PURE__ */ new Set();
        n.conditionalRules.forEach((b) => {
          vr(
            b,
            n,
            c,
            d,
            a,
            f
          ).forEach((F) => u.add(F));
        });
        const y = c[l] || /* @__PURE__ */ new Set();
        jn(y, u) || d((b) => ({
          ...b,
          [l]: u
        }));
      }
      n.childFields && n.childFields.forEach((u) => {
        var y;
        (y = n.fieldMetadata) != null && y.isSubForm ? v(u, n.fieldName, 0) : v(u);
      });
    },
    [c]
  );
  return _r(() => {
    v(t);
  }, [t, v]), _r(() => {
    i({ dependencies: c });
  }, [c, i]), null;
};
var Dr = { exports: {} };
Dr.exports;
var xt;
function Rn() {
  return xt || (xt = 1, function(t, c) {
    var d = 9007199254740991, i = "[object Arguments]", v = "[object Function]", n = "[object GeneratorFunction]", a = "[object Map]", f = "[object Object]", l = "[object Promise]", u = "[object Set]", y = "[object WeakMap]", b = "[object DataView]", m = /[\\^$.*+?()[\]{}|]/g, F = /^\[object .+?Constructor\]$/, U = typeof Te == "object" && Te && Te.Object === Object && Te, R = typeof self == "object" && self && self.Object === Object && self, T = U || R || Function("return this")(), L = c && !c.nodeType && c, w = L && !0 && t && !t.nodeType && t, k = w && w.exports === L;
    function Z(_, P) {
      return _ == null ? void 0 : _[P];
    }
    function je(_) {
      var P = !1;
      if (_ != null && typeof _.toString != "function")
        try {
          P = !!(_ + "");
        } catch {
        }
      return P;
    }
    function G(_, P) {
      return function(M) {
        return _(P(M));
      };
    }
    var Q = Function.prototype, ce = Object.prototype, ye = T["__core-js_shared__"], we = function() {
      var _ = /[^.]+$/.exec(ye && ye.keys && ye.keys.IE_PROTO || "");
      return _ ? "Symbol(src)_1." + _ : "";
    }(), Ue = Q.toString, he = ce.hasOwnProperty, Y = ce.toString, fe = RegExp(
      "^" + Ue.call(he).replace(m, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), ve = k ? T.Buffer : void 0, ie = ce.propertyIsEnumerable, qe = ve ? ve.isBuffer : void 0, ze = G(Object.keys, Object), Fe = le(T, "DataView"), Pe = le(T, "Map"), $e = le(T, "Promise"), se = le(T, "Set"), Ie = le(T, "WeakMap"), fr = !ie.call({ valueOf: 1 }, "valueOf"), N = ee(Fe), De = ee(Pe), ke = ee($e), H = ee(se), Ne = ee(Ie);
    function Ae(_) {
      return Y.call(_);
    }
    function Ye(_) {
      if (!Ve(_) || Re(_))
        return !1;
      var P = Qe(_) || je(_) ? fe : F;
      return P.test(ee(_));
    }
    function le(_, P) {
      var M = Z(_, P);
      return Ye(M) ? M : void 0;
    }
    var pe = Ae;
    (Fe && pe(new Fe(new ArrayBuffer(1))) != b || Pe && pe(new Pe()) != a || $e && pe($e.resolve()) != l || se && pe(new se()) != u || Ie && pe(new Ie()) != y) && (pe = function(_) {
      var P = Y.call(_), M = P == f ? _.constructor : void 0, Me = M ? ee(M) : void 0;
      if (Me)
        switch (Me) {
          case N:
            return b;
          case De:
            return a;
          case ke:
            return l;
          case H:
            return u;
          case Ne:
            return y;
        }
      return P;
    });
    function Re(_) {
      return !!we && we in _;
    }
    function Le(_) {
      var P = _ && _.constructor, M = typeof P == "function" && P.prototype || ce;
      return _ === M;
    }
    function ee(_) {
      if (_ != null) {
        try {
          return Ue.call(_);
        } catch {
        }
        try {
          return _ + "";
        } catch {
        }
      }
      return "";
    }
    function Ke(_) {
      return Ze(_) && he.call(_, "callee") && (!ie.call(_, "callee") || Y.call(_) == i);
    }
    var Xe = Array.isArray;
    function de(_) {
      return _ != null && pr(_.length) && !Qe(_);
    }
    function Ze(_) {
      return er(_) && de(_);
    }
    var lr = qe || _e;
    function Ge(_) {
      if (de(_) && (Xe(_) || typeof _ == "string" || typeof _.splice == "function" || lr(_) || Ke(_)))
        return !_.length;
      var P = pe(_);
      if (P == a || P == u)
        return !_.size;
      if (fr || Le(_))
        return !ze(_).length;
      for (var M in _)
        if (he.call(_, M))
          return !1;
      return !0;
    }
    function Qe(_) {
      var P = Ve(_) ? Y.call(_) : "";
      return P == v || P == n;
    }
    function pr(_) {
      return typeof _ == "number" && _ > -1 && _ % 1 == 0 && _ <= d;
    }
    function Ve(_) {
      var P = typeof _;
      return !!_ && (P == "object" || P == "function");
    }
    function er(_) {
      return !!_ && typeof _ == "object";
    }
    function _e() {
      return !1;
    }
    t.exports = Ge;
  }(Dr, Dr.exports)), Dr.exports;
}
var Cn = Rn();
const xn = /* @__PURE__ */ Xr(Cn);
var Nr = { exports: {} };
Nr.exports;
var Ft;
function Fn() {
  return Ft || (Ft = 1, function(t, c) {
    var d = 200, i = "__lodash_hash_undefined__", v = 1, n = 2, a = 9007199254740991, f = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", y = "[object Boolean]", b = "[object Date]", m = "[object Error]", F = "[object Function]", U = "[object GeneratorFunction]", R = "[object Map]", T = "[object Number]", L = "[object Null]", w = "[object Object]", k = "[object Promise]", Z = "[object Proxy]", je = "[object RegExp]", G = "[object Set]", Q = "[object String]", ce = "[object Symbol]", ye = "[object Undefined]", we = "[object WeakMap]", Ue = "[object ArrayBuffer]", he = "[object DataView]", Y = "[object Float32Array]", fe = "[object Float64Array]", ve = "[object Int8Array]", ie = "[object Int16Array]", qe = "[object Int32Array]", ze = "[object Uint8Array]", Fe = "[object Uint8ClampedArray]", Pe = "[object Uint16Array]", $e = "[object Uint32Array]", se = /[\\^$.*+?()[\]{}|]/g, Ie = /^\[object .+?Constructor\]$/, fr = /^(?:0|[1-9]\d*)$/, N = {};
    N[Y] = N[fe] = N[ve] = N[ie] = N[qe] = N[ze] = N[Fe] = N[Pe] = N[$e] = !0, N[f] = N[l] = N[Ue] = N[y] = N[he] = N[b] = N[m] = N[F] = N[R] = N[T] = N[w] = N[je] = N[G] = N[Q] = N[we] = !1;
    var De = typeof Te == "object" && Te && Te.Object === Object && Te, ke = typeof self == "object" && self && self.Object === Object && self, H = De || ke || Function("return this")(), Ne = c && !c.nodeType && c, Ae = Ne && !0 && t && !t.nodeType && t, Ye = Ae && Ae.exports === Ne, le = Ye && De.process, pe = function() {
      try {
        return le && le.binding && le.binding("util");
      } catch {
      }
    }(), Re = pe && pe.isTypedArray;
    function Le(e, o) {
      for (var p = -1, E = e == null ? 0 : e.length, V = 0, A = []; ++p < E; ) {
        var z = e[p];
        o(z, p, e) && (A[V++] = z);
      }
      return A;
    }
    function ee(e, o) {
      for (var p = -1, E = o.length, V = e.length; ++p < E; )
        e[V + p] = o[p];
      return e;
    }
    function Ke(e, o) {
      for (var p = -1, E = e == null ? 0 : e.length; ++p < E; )
        if (o(e[p], p, e))
          return !0;
      return !1;
    }
    function Xe(e, o) {
      for (var p = -1, E = Array(e); ++p < e; )
        E[p] = o(p);
      return E;
    }
    function de(e) {
      return function(o) {
        return e(o);
      };
    }
    function Ze(e, o) {
      return e.has(o);
    }
    function lr(e, o) {
      return e == null ? void 0 : e[o];
    }
    function Ge(e) {
      var o = -1, p = Array(e.size);
      return e.forEach(function(E, V) {
        p[++o] = [V, E];
      }), p;
    }
    function Qe(e, o) {
      return function(p) {
        return e(o(p));
      };
    }
    function pr(e) {
      var o = -1, p = Array(e.size);
      return e.forEach(function(E) {
        p[++o] = E;
      }), p;
    }
    var Ve = Array.prototype, er = Function.prototype, _e = Object.prototype, _ = H["__core-js_shared__"], P = er.toString, M = _e.hasOwnProperty, Me = function() {
      var e = /[^.]+$/.exec(_ && _.keys && _.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }(), br = _e.toString, dr = RegExp(
      "^" + P.call(M).replace(se, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Sr = Ye ? H.Buffer : void 0, rr = H.Symbol, s = H.Uint8Array, h = _e.propertyIsEnumerable, O = Ve.splice, $ = rr ? rr.toStringTag : void 0, ue = Object.getOwnPropertySymbols, Ce = Sr ? Sr.isBuffer : void 0, tr = Qe(Object.keys, Object), Er = wr(H, "DataView"), gr = wr(H, "Map"), Or = wr(H, "Promise"), Rr = wr(H, "Set"), Tr = wr(H, "WeakMap"), nr = wr(Object, "create"), Qr = yr(Er), et = yr(gr), kr = yr(Or), Gr = yr(Rr), rt = yr(Tr), Vr = rr ? rr.prototype : void 0, Cr = Vr ? Vr.valueOf : void 0;
    function Be(e) {
      var o = -1, p = e == null ? 0 : e.length;
      for (this.clear(); ++o < p; ) {
        var E = e[o];
        this.set(E[0], E[1]);
      }
    }
    function r() {
      this.__data__ = nr ? nr(null) : {}, this.size = 0;
    }
    function g(e) {
      var o = this.has(e) && delete this.__data__[e];
      return this.size -= o ? 1 : 0, o;
    }
    function S(e) {
      var o = this.__data__;
      if (nr) {
        var p = o[e];
        return p === i ? void 0 : p;
      }
      return M.call(o, e) ? o[e] : void 0;
    }
    function j(e) {
      var o = this.__data__;
      return nr ? o[e] !== void 0 : M.call(o, e);
    }
    function D(e, o) {
      var p = this.__data__;
      return this.size += this.has(e) ? 0 : 1, p[e] = nr && o === void 0 ? i : o, this;
    }
    Be.prototype.clear = r, Be.prototype.delete = g, Be.prototype.get = S, Be.prototype.has = j, Be.prototype.set = D;
    function x(e) {
      var o = -1, p = e == null ? 0 : e.length;
      for (this.clear(); ++o < p; ) {
        var E = e[o];
        this.set(E[0], E[1]);
      }
    }
    function I() {
      this.__data__ = [], this.size = 0;
    }
    function C(e) {
      var o = this.__data__, p = Br(o, e);
      if (p < 0)
        return !1;
      var E = o.length - 1;
      return p == E ? o.pop() : O.call(o, p, 1), --this.size, !0;
    }
    function re(e) {
      var o = this.__data__, p = Br(o, e);
      return p < 0 ? void 0 : o[p][1];
    }
    function W(e) {
      return Br(this.__data__, e) > -1;
    }
    function q(e, o) {
      var p = this.__data__, E = Br(p, e);
      return E < 0 ? (++this.size, p.push([e, o])) : p[E][1] = o, this;
    }
    x.prototype.clear = I, x.prototype.delete = C, x.prototype.get = re, x.prototype.has = W, x.prototype.set = q;
    function K(e) {
      var o = -1, p = e == null ? 0 : e.length;
      for (this.clear(); ++o < p; ) {
        var E = e[o];
        this.set(E[0], E[1]);
      }
    }
    function or() {
      this.size = 0, this.__data__ = {
        hash: new Be(),
        map: new (gr || x)(),
        string: new Be()
      };
    }
    function He(e) {
      var o = Hr(this, e).delete(e);
      return this.size -= o ? 1 : 0, o;
    }
    function ne(e) {
      return Hr(this, e).get(e);
    }
    function xr(e) {
      return Hr(this, e).has(e);
    }
    function tt(e, o) {
      var p = Hr(this, e), E = p.size;
      return p.set(e, o), this.size += p.size == E ? 0 : 1, this;
    }
    K.prototype.clear = or, K.prototype.delete = He, K.prototype.get = ne, K.prototype.has = xr, K.prototype.set = tt;
    function jr(e) {
      var o = -1, p = e == null ? 0 : e.length;
      for (this.__data__ = new K(); ++o < p; )
        this.add(e[o]);
    }
    function Lt(e) {
      return this.__data__.set(e, i), this;
    }
    function Mt(e) {
      return this.__data__.has(e);
    }
    jr.prototype.add = jr.prototype.push = Lt, jr.prototype.has = Mt;
    function ar(e) {
      var o = this.__data__ = new x(e);
      this.size = o.size;
    }
    function Ut() {
      this.__data__ = new x(), this.size = 0;
    }
    function kt(e) {
      var o = this.__data__, p = o.delete(e);
      return this.size = o.size, p;
    }
    function Gt(e) {
      return this.__data__.get(e);
    }
    function Vt(e) {
      return this.__data__.has(e);
    }
    function Bt(e, o) {
      var p = this.__data__;
      if (p instanceof x) {
        var E = p.__data__;
        if (!gr || E.length < d - 1)
          return E.push([e, o]), this.size = ++p.size, this;
        p = this.__data__ = new K(E);
      }
      return p.set(e, o), this.size = p.size, this;
    }
    ar.prototype.clear = Ut, ar.prototype.delete = kt, ar.prototype.get = Gt, ar.prototype.has = Vt, ar.prototype.set = Bt;
    function Ht(e, o) {
      var p = Wr(e), E = !p && an(e), V = !p && !E && nt(e), A = !p && !E && !V && Et(e), z = p || E || V || A, X = z ? Xe(e.length, String) : [], te = X.length;
      for (var J in e)
        M.call(e, J) && !(z && // Safari 9 has enumerable `arguments.length` in strict mode.
        (J == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        V && (J == "offset" || J == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        A && (J == "buffer" || J == "byteLength" || J == "byteOffset") || // Skip index properties.
        en(J, te))) && X.push(J);
      return X;
    }
    function Br(e, o) {
      for (var p = e.length; p--; )
        if (_t(e[p][0], o))
          return p;
      return -1;
    }
    function Wt(e, o, p) {
      var E = o(e);
      return Wr(e) ? E : ee(E, p(e));
    }
    function Fr(e) {
      return e == null ? e === void 0 ? ye : L : $ && $ in Object(e) ? Zt(e) : on(e);
    }
    function gt(e) {
      return Pr(e) && Fr(e) == f;
    }
    function yt(e, o, p, E, V) {
      return e === o ? !0 : e == null || o == null || !Pr(e) && !Pr(o) ? e !== e && o !== o : Jt(e, o, p, E, yt, V);
    }
    function Jt(e, o, p, E, V, A) {
      var z = Wr(e), X = Wr(o), te = z ? l : ir(e), J = X ? l : ir(o);
      te = te == f ? w : te, J = J == f ? w : J;
      var me = te == w, xe = J == w, oe = te == J;
      if (oe && nt(e)) {
        if (!nt(o))
          return !1;
        z = !0, me = !1;
      }
      if (oe && !me)
        return A || (A = new ar()), z || Et(e) ? ht(e, o, p, E, V, A) : Kt(e, o, te, p, E, V, A);
      if (!(p & v)) {
        var Se = me && M.call(e, "__wrapped__"), Ee = xe && M.call(o, "__wrapped__");
        if (Se || Ee) {
          var sr = Se ? e.value() : e, We = Ee ? o.value() : o;
          return A || (A = new ar()), V(sr, We, p, E, A);
        }
      }
      return oe ? (A || (A = new ar()), Xt(e, o, p, E, V, A)) : !1;
    }
    function qt(e) {
      if (!St(e) || tn(e))
        return !1;
      var o = mt(e) ? dr : Ie;
      return o.test(yr(e));
    }
    function zt(e) {
      return Pr(e) && bt(e.length) && !!N[Fr(e)];
    }
    function Yt(e) {
      if (!nn(e))
        return tr(e);
      var o = [];
      for (var p in Object(e))
        M.call(e, p) && p != "constructor" && o.push(p);
      return o;
    }
    function ht(e, o, p, E, V, A) {
      var z = p & v, X = e.length, te = o.length;
      if (X != te && !(z && te > X))
        return !1;
      var J = A.get(e);
      if (J && A.get(o))
        return J == o;
      var me = -1, xe = !0, oe = p & n ? new jr() : void 0;
      for (A.set(e, o), A.set(o, e); ++me < X; ) {
        var Se = e[me], Ee = o[me];
        if (E)
          var sr = z ? E(Ee, Se, me, o, e, A) : E(Se, Ee, me, e, o, A);
        if (sr !== void 0) {
          if (sr)
            continue;
          xe = !1;
          break;
        }
        if (oe) {
          if (!Ke(o, function(We, hr) {
            if (!Ze(oe, hr) && (Se === We || V(Se, We, p, E, A)))
              return oe.push(hr);
          })) {
            xe = !1;
            break;
          }
        } else if (!(Se === Ee || V(Se, Ee, p, E, A))) {
          xe = !1;
          break;
        }
      }
      return A.delete(e), A.delete(o), xe;
    }
    function Kt(e, o, p, E, V, A, z) {
      switch (p) {
        case he:
          if (e.byteLength != o.byteLength || e.byteOffset != o.byteOffset)
            return !1;
          e = e.buffer, o = o.buffer;
        case Ue:
          return !(e.byteLength != o.byteLength || !A(new s(e), new s(o)));
        case y:
        case b:
        case T:
          return _t(+e, +o);
        case m:
          return e.name == o.name && e.message == o.message;
        case je:
        case Q:
          return e == o + "";
        case R:
          var X = Ge;
        case G:
          var te = E & v;
          if (X || (X = pr), e.size != o.size && !te)
            return !1;
          var J = z.get(e);
          if (J)
            return J == o;
          E |= n, z.set(e, o);
          var me = ht(X(e), X(o), E, V, A, z);
          return z.delete(e), me;
        case ce:
          if (Cr)
            return Cr.call(e) == Cr.call(o);
      }
      return !1;
    }
    function Xt(e, o, p, E, V, A) {
      var z = p & v, X = vt(e), te = X.length, J = vt(o), me = J.length;
      if (te != me && !z)
        return !1;
      for (var xe = te; xe--; ) {
        var oe = X[xe];
        if (!(z ? oe in o : M.call(o, oe)))
          return !1;
      }
      var Se = A.get(e);
      if (Se && A.get(o))
        return Se == o;
      var Ee = !0;
      A.set(e, o), A.set(o, e);
      for (var sr = z; ++xe < te; ) {
        oe = X[xe];
        var We = e[oe], hr = o[oe];
        if (E)
          var Ot = z ? E(hr, We, oe, o, e, A) : E(We, hr, oe, e, o, A);
        if (!(Ot === void 0 ? We === hr || V(We, hr, p, E, A) : Ot)) {
          Ee = !1;
          break;
        }
        sr || (sr = oe == "constructor");
      }
      if (Ee && !sr) {
        var Jr = e.constructor, qr = o.constructor;
        Jr != qr && "constructor" in e && "constructor" in o && !(typeof Jr == "function" && Jr instanceof Jr && typeof qr == "function" && qr instanceof qr) && (Ee = !1);
      }
      return A.delete(e), A.delete(o), Ee;
    }
    function vt(e) {
      return Wt(e, cn, Qt);
    }
    function Hr(e, o) {
      var p = e.__data__;
      return rn(o) ? p[typeof o == "string" ? "string" : "hash"] : p.map;
    }
    function wr(e, o) {
      var p = lr(e, o);
      return qt(p) ? p : void 0;
    }
    function Zt(e) {
      var o = M.call(e, $), p = e[$];
      try {
        e[$] = void 0;
        var E = !0;
      } catch {
      }
      var V = br.call(e);
      return E && (o ? e[$] = p : delete e[$]), V;
    }
    var Qt = ue ? function(e) {
      return e == null ? [] : (e = Object(e), Le(ue(e), function(o) {
        return h.call(e, o);
      }));
    } : fn, ir = Fr;
    (Er && ir(new Er(new ArrayBuffer(1))) != he || gr && ir(new gr()) != R || Or && ir(Or.resolve()) != k || Rr && ir(new Rr()) != G || Tr && ir(new Tr()) != we) && (ir = function(e) {
      var o = Fr(e), p = o == w ? e.constructor : void 0, E = p ? yr(p) : "";
      if (E)
        switch (E) {
          case Qr:
            return he;
          case et:
            return R;
          case kr:
            return k;
          case Gr:
            return G;
          case rt:
            return we;
        }
      return o;
    });
    function en(e, o) {
      return o = o ?? a, !!o && (typeof e == "number" || fr.test(e)) && e > -1 && e % 1 == 0 && e < o;
    }
    function rn(e) {
      var o = typeof e;
      return o == "string" || o == "number" || o == "symbol" || o == "boolean" ? e !== "__proto__" : e === null;
    }
    function tn(e) {
      return !!Me && Me in e;
    }
    function nn(e) {
      var o = e && e.constructor, p = typeof o == "function" && o.prototype || _e;
      return e === p;
    }
    function on(e) {
      return br.call(e);
    }
    function yr(e) {
      if (e != null) {
        try {
          return P.call(e);
        } catch {
        }
        try {
          return e + "";
        } catch {
        }
      }
      return "";
    }
    function _t(e, o) {
      return e === o || e !== e && o !== o;
    }
    var an = gt(/* @__PURE__ */ function() {
      return arguments;
    }()) ? gt : function(e) {
      return Pr(e) && M.call(e, "callee") && !h.call(e, "callee");
    }, Wr = Array.isArray;
    function sn(e) {
      return e != null && bt(e.length) && !mt(e);
    }
    var nt = Ce || ln;
    function un(e, o) {
      return yt(e, o);
    }
    function mt(e) {
      if (!St(e))
        return !1;
      var o = Fr(e);
      return o == F || o == U || o == u || o == Z;
    }
    function bt(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= a;
    }
    function St(e) {
      var o = typeof e;
      return e != null && (o == "object" || o == "function");
    }
    function Pr(e) {
      return e != null && typeof e == "object";
    }
    var Et = Re ? de(Re) : zt;
    function cn(e) {
      return sn(e) ? Ht(e) : Yt(e);
    }
    function fn() {
      return [];
    }
    function ln() {
      return !1;
    }
    t.exports = un;
  }(Nr, Nr.exports)), Nr.exports;
}
var Pn = Fn();
const ft = /* @__PURE__ */ Xr(Pn);
var Yr = { exports: {} }, $n = Yr.exports, Pt;
function In() {
  return Pt || (Pt = 1, function(t, c) {
    (function(d, i) {
      t.exports = i();
    })($n, function() {
      Array.isArray || (Array.isArray = function(n) {
        return Object.prototype.toString.call(n) === "[object Array]";
      });
      function d(n) {
        for (var a = [], f = 0, l = n.length; f < l; f++)
          a.indexOf(n[f]) === -1 && a.push(n[f]);
        return a;
      }
      var i = {}, v = {
        "==": function(n, a) {
          return n == a;
        },
        "===": function(n, a) {
          return n === a;
        },
        "!=": function(n, a) {
          return n != a;
        },
        "!==": function(n, a) {
          return n !== a;
        },
        ">": function(n, a) {
          return n > a;
        },
        ">=": function(n, a) {
          return n >= a;
        },
        "<": function(n, a, f) {
          return f === void 0 ? n < a : n < a && a < f;
        },
        "<=": function(n, a, f) {
          return f === void 0 ? n <= a : n <= a && a <= f;
        },
        "!!": function(n) {
          return i.truthy(n);
        },
        "!": function(n) {
          return !i.truthy(n);
        },
        "%": function(n, a) {
          return n % a;
        },
        log: function(n) {
          return console.log(n), n;
        },
        in: function(n, a) {
          return !a || typeof a.indexOf > "u" ? !1 : a.indexOf(n) !== -1;
        },
        cat: function() {
          return Array.prototype.join.call(arguments, "");
        },
        substr: function(n, a, f) {
          if (f < 0) {
            var l = String(n).substr(a);
            return l.substr(0, l.length + f);
          }
          return String(n).substr(a, f);
        },
        "+": function() {
          return Array.prototype.reduce.call(arguments, function(n, a) {
            return parseFloat(n, 10) + parseFloat(a, 10);
          }, 0);
        },
        "*": function() {
          return Array.prototype.reduce.call(arguments, function(n, a) {
            return parseFloat(n, 10) * parseFloat(a, 10);
          });
        },
        "-": function(n, a) {
          return a === void 0 ? -n : n - a;
        },
        "/": function(n, a) {
          return n / a;
        },
        min: function() {
          return Math.min.apply(this, arguments);
        },
        max: function() {
          return Math.max.apply(this, arguments);
        },
        merge: function() {
          return Array.prototype.reduce.call(arguments, function(n, a) {
            return n.concat(a);
          }, []);
        },
        var: function(n, a) {
          var f = a === void 0 ? null : a, l = this;
          if (typeof n > "u" || n === "" || n === null)
            return l;
          for (var u = String(n).split("."), y = 0; y < u.length; y++)
            if (l == null || (l = l[u[y]], l === void 0))
              return f;
          return l;
        },
        missing: function() {
          for (var n = [], a = Array.isArray(arguments[0]) ? arguments[0] : arguments, f = 0; f < a.length; f++) {
            var l = a[f], u = i.apply({ var: l }, this);
            (u === null || u === "") && n.push(l);
          }
          return n;
        },
        missing_some: function(n, a) {
          var f = i.apply({ missing: a }, this);
          return a.length - f.length >= n ? [] : f;
        }
      };
      return i.is_logic = function(n) {
        return typeof n == "object" && // An object
        n !== null && // but not null
        !Array.isArray(n) && // and not an array
        Object.keys(n).length === 1;
      }, i.truthy = function(n) {
        return Array.isArray(n) && n.length === 0 ? !1 : !!n;
      }, i.get_operator = function(n) {
        return Object.keys(n)[0];
      }, i.get_values = function(n) {
        return n[i.get_operator(n)];
      }, i.apply = function(n, a) {
        if (Array.isArray(n))
          return n.map(function(T) {
            return i.apply(T, a);
          });
        if (!i.is_logic(n))
          return n;
        var f = i.get_operator(n), l = n[f], u, y, b, m, F;
        if (Array.isArray(l) || (l = [l]), f === "if" || f == "?:") {
          for (u = 0; u < l.length - 1; u += 2)
            if (i.truthy(i.apply(l[u], a)))
              return i.apply(l[u + 1], a);
          return l.length === u + 1 ? i.apply(l[u], a) : null;
        } else if (f === "and") {
          for (u = 0; u < l.length; u += 1)
            if (y = i.apply(l[u], a), !i.truthy(y))
              return y;
          return y;
        } else if (f === "or") {
          for (u = 0; u < l.length; u += 1)
            if (y = i.apply(l[u], a), i.truthy(y))
              return y;
          return y;
        } else {
          if (f === "filter")
            return m = i.apply(l[0], a), b = l[1], Array.isArray(m) ? m.filter(function(T) {
              return i.truthy(i.apply(b, T));
            }) : [];
          if (f === "map")
            return m = i.apply(l[0], a), b = l[1], Array.isArray(m) ? m.map(function(T) {
              return i.apply(b, T);
            }) : [];
          if (f === "reduce")
            return m = i.apply(l[0], a), b = l[1], F = typeof l[2] < "u" ? i.apply(l[2], a) : null, Array.isArray(m) ? m.reduce(
              function(T, L) {
                return i.apply(
                  b,
                  { current: L, accumulator: T }
                );
              },
              F
            ) : F;
          if (f === "all") {
            if (m = i.apply(l[0], a), b = l[1], !Array.isArray(m) || !m.length)
              return !1;
            for (u = 0; u < m.length; u += 1)
              if (!i.truthy(i.apply(b, m[u])))
                return !1;
            return !0;
          } else if (f === "none") {
            if (m = i.apply(l[0], a), b = l[1], !Array.isArray(m) || !m.length)
              return !0;
            for (u = 0; u < m.length; u += 1)
              if (i.truthy(i.apply(b, m[u])))
                return !1;
            return !0;
          } else if (f === "some") {
            if (m = i.apply(l[0], a), b = l[1], !Array.isArray(m) || !m.length)
              return !1;
            for (u = 0; u < m.length; u += 1)
              if (i.truthy(i.apply(b, m[u])))
                return !0;
            return !1;
          }
        }
        if (l = l.map(function(T) {
          return i.apply(T, a);
        }), v.hasOwnProperty(f) && typeof v[f] == "function")
          return v[f].apply(a, l);
        if (f.indexOf(".") > 0) {
          var U = String(f).split("."), R = v;
          for (u = 0; u < U.length; u++) {
            if (!R.hasOwnProperty(U[u]))
              throw new Error("Unrecognized operation " + f + " (failed at " + U.slice(0, u + 1).join(".") + ")");
            R = R[U[u]];
          }
          return R.apply(a, l);
        }
        throw new Error("Unrecognized operation " + f);
      }, i.uses_data = function(n) {
        var a = [];
        if (i.is_logic(n)) {
          var f = i.get_operator(n), l = n[f];
          Array.isArray(l) || (l = [l]), f === "var" ? a.push(l[0]) : l.forEach(function(u) {
            a.push.apply(a, i.uses_data(u));
          });
        }
        return d(a);
      }, i.add_operation = function(n, a) {
        v[n] = a;
      }, i.rm_operation = function(n) {
        delete v[n];
      }, i.rule_like = function(n, a) {
        if (a === n || a === "@")
          return !0;
        if (a === "number")
          return typeof n == "number";
        if (a === "string")
          return typeof n == "string";
        if (a === "array")
          return Array.isArray(n) && !i.is_logic(n);
        if (i.is_logic(a)) {
          if (i.is_logic(n)) {
            var f = i.get_operator(a), l = i.get_operator(n);
            if (f === "@" || f === l)
              return i.rule_like(
                i.get_values(n, !1),
                i.get_values(a, !1)
              );
          }
          return !1;
        }
        if (Array.isArray(a))
          if (Array.isArray(n)) {
            if (a.length !== n.length)
              return !1;
            for (var u = 0; u < a.length; u += 1)
              if (!i.rule_like(n[u], a[u]))
                return !1;
            return !0;
          } else
            return !1;
        return !1;
      }, i;
    });
  }(Yr)), Yr.exports;
}
var Dn = In();
const Kr = /* @__PURE__ */ Xr(Dn), Nn = [
  ...Object.values(Oe),
  ...Object.values(Lr),
  ...Object.values(ge)
], mr = (t) => Object.keys(t).some((c) => Nn.includes(c)), ur = (t) => Object.keys(t).some(
  (c) => [...Dt, ...Object.values(ge)].includes(
    c
  )
), cr = (t, c) => {
  const { parseTarget: d } = t;
  if (ur(c))
    return Kr.apply(c);
  const i = Object.values(
    Oe
  );
  if (!Object.keys(c).includes(Lr.onField))
    throw new Error(
      `Missing $field for custom operation: ${JSON.stringify(c)}`
    );
  const v = d(
    c[Lr.onField]
  );
  return Object.keys(c).filter((n) => n !== Lr.onField).map((n) => {
    if (!i.includes(n))
      throw new Error(
        `Invalid operation ${n} in operation ${JSON.stringify(
          c
        )}`
      );
    return Nt[n](t)(
      c[n],
      v
    );
  });
}, Ln = (t) => (...c) => Array.isArray(c) ? c.map(
  (d) => cr(t, d)
) : (console.warn(
  `Invalid value for actions operation: ${JSON.stringify(
    c
  )}`
), []), Zr = (t, c) => {
  const d = (i) => Array.isArray(i) ? i.map((v) => d(v)) : typeof i == "object" && i !== null ? mr(i) || ur(i) ? cr(t, i) : Zr(t, i) : i;
  return Object.entries(c).reduce(
    (i, [v, n]) => ({
      ...i,
      [v]: d(n)
    }),
    {}
  );
}, Mn = (t) => {
  const { parseTarget: c } = t;
  return (d, i) => {
    const v = c(i);
    let n = d;
    typeof d == "object" && (n = Zr(t, d));
    const a = be.getState(), f = a.propsSetters[v];
    if (!f) {
      console.warn(`No props setter found for ${v}`, {
        propsSetter: a.propsSetters,
        condition: d
      });
      return;
    }
    f(n);
  };
};
var st, $t;
function Un() {
  if ($t) return st;
  $t = 1;
  var t = "Expected a function", c = "__lodash_hash_undefined__", d = "[object Function]", i = "[object GeneratorFunction]", v = "[object Symbol]", n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a = /^\w*$/, f = /^\./, l = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, u = /[\\^$.*+?()[\]{}|]/g, y = /\\(\\)?/g, b = /^\[object .+?Constructor\]$/, m = typeof Te == "object" && Te && Te.Object === Object && Te, F = typeof self == "object" && self && self.Object === Object && self, U = m || F || Function("return this")();
  function R(s, h) {
    return s == null ? void 0 : s[h];
  }
  function T(s) {
    var h = !1;
    if (s != null && typeof s.toString != "function")
      try {
        h = !!(s + "");
      } catch {
      }
    return h;
  }
  var L = Array.prototype, w = Function.prototype, k = Object.prototype, Z = U["__core-js_shared__"], je = function() {
    var s = /[^.]+$/.exec(Z && Z.keys && Z.keys.IE_PROTO || "");
    return s ? "Symbol(src)_1." + s : "";
  }(), G = w.toString, Q = k.hasOwnProperty, ce = k.toString, ye = RegExp(
    "^" + G.call(Q).replace(u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), we = U.Symbol, Ue = L.splice, he = Ze(U, "Map"), Y = Ze(Object, "create"), fe = we ? we.prototype : void 0, ve = fe ? fe.toString : void 0;
  function ie(s) {
    var h = -1, O = s ? s.length : 0;
    for (this.clear(); ++h < O; ) {
      var $ = s[h];
      this.set($[0], $[1]);
    }
  }
  function qe() {
    this.__data__ = Y ? Y(null) : {};
  }
  function ze(s) {
    return this.has(s) && delete this.__data__[s];
  }
  function Fe(s) {
    var h = this.__data__;
    if (Y) {
      var O = h[s];
      return O === c ? void 0 : O;
    }
    return Q.call(h, s) ? h[s] : void 0;
  }
  function Pe(s) {
    var h = this.__data__;
    return Y ? h[s] !== void 0 : Q.call(h, s);
  }
  function $e(s, h) {
    var O = this.__data__;
    return O[s] = Y && h === void 0 ? c : h, this;
  }
  ie.prototype.clear = qe, ie.prototype.delete = ze, ie.prototype.get = Fe, ie.prototype.has = Pe, ie.prototype.set = $e;
  function se(s) {
    var h = -1, O = s ? s.length : 0;
    for (this.clear(); ++h < O; ) {
      var $ = s[h];
      this.set($[0], $[1]);
    }
  }
  function Ie() {
    this.__data__ = [];
  }
  function fr(s) {
    var h = this.__data__, O = Re(h, s);
    if (O < 0)
      return !1;
    var $ = h.length - 1;
    return O == $ ? h.pop() : Ue.call(h, O, 1), !0;
  }
  function N(s) {
    var h = this.__data__, O = Re(h, s);
    return O < 0 ? void 0 : h[O][1];
  }
  function De(s) {
    return Re(this.__data__, s) > -1;
  }
  function ke(s, h) {
    var O = this.__data__, $ = Re(O, s);
    return $ < 0 ? O.push([s, h]) : O[$][1] = h, this;
  }
  se.prototype.clear = Ie, se.prototype.delete = fr, se.prototype.get = N, se.prototype.has = De, se.prototype.set = ke;
  function H(s) {
    var h = -1, O = s ? s.length : 0;
    for (this.clear(); ++h < O; ) {
      var $ = s[h];
      this.set($[0], $[1]);
    }
  }
  function Ne() {
    this.__data__ = {
      hash: new ie(),
      map: new (he || se)(),
      string: new ie()
    };
  }
  function Ae(s) {
    return de(this, s).delete(s);
  }
  function Ye(s) {
    return de(this, s).get(s);
  }
  function le(s) {
    return de(this, s).has(s);
  }
  function pe(s, h) {
    return de(this, s).set(s, h), this;
  }
  H.prototype.clear = Ne, H.prototype.delete = Ae, H.prototype.get = Ye, H.prototype.has = le, H.prototype.set = pe;
  function Re(s, h) {
    for (var O = s.length; O--; )
      if (_(s[O][0], h))
        return O;
    return -1;
  }
  function Le(s, h) {
    h = lr(h, s) ? [h] : Xe(h);
    for (var O = 0, $ = h.length; s != null && O < $; )
      s = s[Ve(h[O++])];
    return O && O == $ ? s : void 0;
  }
  function ee(s) {
    if (!Me(s) || Qe(s))
      return !1;
    var h = M(s) || T(s) ? ye : b;
    return h.test(er(s));
  }
  function Ke(s) {
    if (typeof s == "string")
      return s;
    if (dr(s))
      return ve ? ve.call(s) : "";
    var h = s + "";
    return h == "0" && 1 / s == -1 / 0 ? "-0" : h;
  }
  function Xe(s) {
    return P(s) ? s : pr(s);
  }
  function de(s, h) {
    var O = s.__data__;
    return Ge(h) ? O[typeof h == "string" ? "string" : "hash"] : O.map;
  }
  function Ze(s, h) {
    var O = R(s, h);
    return ee(O) ? O : void 0;
  }
  function lr(s, h) {
    if (P(s))
      return !1;
    var O = typeof s;
    return O == "number" || O == "symbol" || O == "boolean" || s == null || dr(s) ? !0 : a.test(s) || !n.test(s) || h != null && s in Object(h);
  }
  function Ge(s) {
    var h = typeof s;
    return h == "string" || h == "number" || h == "symbol" || h == "boolean" ? s !== "__proto__" : s === null;
  }
  function Qe(s) {
    return !!je && je in s;
  }
  var pr = _e(function(s) {
    s = Sr(s);
    var h = [];
    return f.test(s) && h.push(""), s.replace(l, function(O, $, ue, Ce) {
      h.push(ue ? Ce.replace(y, "$1") : $ || O);
    }), h;
  });
  function Ve(s) {
    if (typeof s == "string" || dr(s))
      return s;
    var h = s + "";
    return h == "0" && 1 / s == -1 / 0 ? "-0" : h;
  }
  function er(s) {
    if (s != null) {
      try {
        return G.call(s);
      } catch {
      }
      try {
        return s + "";
      } catch {
      }
    }
    return "";
  }
  function _e(s, h) {
    if (typeof s != "function" || h && typeof h != "function")
      throw new TypeError(t);
    var O = function() {
      var $ = arguments, ue = h ? h.apply(this, $) : $[0], Ce = O.cache;
      if (Ce.has(ue))
        return Ce.get(ue);
      var tr = s.apply(this, $);
      return O.cache = Ce.set(ue, tr), tr;
    };
    return O.cache = new (_e.Cache || H)(), O;
  }
  _e.Cache = H;
  function _(s, h) {
    return s === h || s !== s && h !== h;
  }
  var P = Array.isArray;
  function M(s) {
    var h = Me(s) ? ce.call(s) : "";
    return h == d || h == i;
  }
  function Me(s) {
    var h = typeof s;
    return !!s && (h == "object" || h == "function");
  }
  function br(s) {
    return !!s && typeof s == "object";
  }
  function dr(s) {
    return typeof s == "symbol" || br(s) && ce.call(s) == v;
  }
  function Sr(s) {
    return s == null ? "" : Ke(s);
  }
  function rr(s, h, O) {
    var $ = s == null ? void 0 : Le(s, h);
    return $ === void 0 ? O : $;
  }
  return st = rr, st;
}
var kn = Un();
const Gn = /* @__PURE__ */ Xr(kn), Vn = (t) => {
  const { formInstance: c, parseTarget: d } = t;
  return (i, v) => {
    const n = d(v);
    if (!Array.isArray(i))
      throw new Error(
        `Invalid value for $setError operation: ${JSON.stringify(i)}`
      );
    return i.map((a) => {
      const f = ur(a) || mr(a) ? cr(t, a) : a;
      if (!f)
        return;
      const l = c.formState.errors, u = Gn(l, n), y = c.getFieldState(n), b = f.ruleValue === !0 && (y.isTouched || y.isDirty) && (!u || u.type !== f.ruleType || u.message !== f.errorMessage), m = f.ruleValue === null && u && u.type === f.ruleType && (y.isTouched || y.isDirty);
      b ? c.setError(
        n,
        {
          type: f.ruleType,
          message: f.errorMessage
        },
        { shouldFocus: !0 }
      ) : m && c.clearErrors(n);
    });
  };
}, Bn = (t) => {
  const { parseTarget: c } = t;
  return (d, i) => {
    const v = c(i);
    let n = d;
    if (typeof d == "object" && !Array.isArray(d) && (n = Zr(t, d)), !Array.isArray(n)) {
      console.warn(
        `Invalid value for $setValidations operation: ${n} on target: ${v}`
      );
      return;
    }
    const a = be.getState(), f = a.validationsSetters[v];
    if (!f) {
      console.warn(`No validations setter found for ${v}`, {
        validationsSetter: a.validationsSetters,
        condition: d
      });
      return;
    }
    f(n);
  };
}, Hn = (t) => {
  const { formInstance: c, parseTarget: d } = t;
  return (i, v) => {
    const n = d(v);
    let a = i;
    (ur(i) || mr(i)) && (a = cr(t, i));
    const f = c.getValues(n);
    ft(f, a) || c.setValue(n, a, {
      shouldValidate: !0,
      shouldDirty: !0
    });
  };
}, Wn = (t) => {
  const { parseTarget: c } = t;
  return (d, i) => {
    var b;
    const v = c(i);
    let n = d;
    if ((ur(n) || mr(n)) && (n = cr(
      t,
      n
    )), !Array.isArray(n)) {
      console.warn(
        `Invalid value for $fireEvent operation: ${JSON.stringify(n)}`
      );
      return;
    }
    const [a, f] = n;
    let l = a, u = f;
    typeof l == "object" && (ur(l) || mr(l)) && (l = cr(t, l)), typeof u == "object" && (u = Zr(t, u));
    const y = be.getState().callbacks;
    (b = y[v]) == null || b.call(y, l, u);
  };
}, Jn = (t) => {
  const { context: c } = t;
  return (d) => {
    let i = d;
    return (ur(d) || mr(d)) && (i = cr(t, d)), c[i];
  };
}, qn = (t) => {
  const { formInstance: c, parseTarget: d } = t;
  return (...i) => {
    const v = i;
    if (!Array.isArray(v)) {
      console.warn(
        `Invalid value for valueOfField operation: ${JSON.stringify(
          v
        )}`
      );
      return;
    }
    const n = c.getValues(
      v.map((a) => {
        let f = a;
        if (typeof a == "object" && (ur(a) || mr(a)) && (f = cr(t, a)), typeof f != "string")
          throw new Error(
            `Invalid value for valueOfField: ${f} for operator ${JSON.stringify(
              a
            )}`
          );
        return d(f);
      })
    );
    return n.length <= 1 ? n[0] : n;
  };
}, Nt = {
  [Oe.setFieldValue]: Hn,
  [Oe.setFieldError]: Vn,
  [Oe.setFieldValidations]: Bn,
  [Oe.setComponentProps]: Mn,
  [Oe.triggerEvent]: Wn,
  [ge.valueOfField]: qn,
  [ge.valueFromContext]: Jn,
  [ge.actions]: Ln
}, ut = ({
  formInstance: t,
  operator: c,
  field: d,
  context: i,
  subFormName: v,
  instanceIndex: n
}) => {
  const f = {
    field: d,
    formInstance: t,
    context: i,
    parseTarget: (l) => Tn(l) && v && n !== void 0 ? `${v}.${n}.${l}` : l
  };
  return Nt[c](f);
}, lt = pn({}), pt = ({
  field: t,
  dependencies: c,
  subFormName: d,
  instanceIndex: i
}) => {
  const v = Ur(), n = It(lt), a = dn({
    name: c,
    control: v.control
  }), f = ae(
    () => ({
      formInstance: v,
      field: t,
      context: n,
      instanceIndex: i,
      subFormName: d
    }),
    [v, t, n, i, d]
  ), l = ae(
    () => ({
      [ge.valueOfField]: ut({
        operator: ge.valueOfField,
        ...f
      }),
      [ge.valueFromContext]: ut({
        operator: ge.valueFromContext,
        ...f
      }),
      [ge.actions]: ut({
        operator: ge.actions,
        ...f
      })
    }),
    [f]
  );
  return _r(() => (t != null && t.conditionalRules && (Object.entries(l).forEach(([u, y]) => {
    Kr.add_operation(u, y);
  }), t.conditionalRules.forEach((u) => Kr.apply(u))), () => {
    Object.keys(l).forEach((u) => {
      Kr.rm_operation(u);
    });
  }), [a, n, t == null ? void 0 : t.conditionalRules, l]), t;
}, zn = ({
  field: t,
  component: c,
  resolvedProps: d = {},
  subFormName: i,
  instanceIndex: v,
  subFormInstance: n,
  dependencies: a = []
}) => {
  const f = c, { setFormState: l } = be(), u = Ur(), [y, b] = Ar(
    t.componentProps ?? {}
  ), [m, F] = Ar(
    t.validationRules ?? []
  ), U = ct(
    (G) => {
      !xn(G) && !ft(m, G) && F(Ct(G, m));
    },
    [m]
  ), R = ct(
    (G) => {
      const Q = { ...y, ...G };
      ft(y, Q) || b(Q);
    },
    [y]
  );
  _r(() => {
    const G = be.getState();
    G.propsSetters[t.fieldName] = R, G.validationsSetters[t.fieldName] = U, l(G);
  }, [y, m, t.fieldName, R, U]);
  const T = ae(
    () => ({
      ...(t == null ? void 0 : t.componentProps) ?? {},
      ...d,
      ...y ?? {}
    }),
    [d, y, t == null ? void 0 : t.componentProps]
  ), L = ae(
    () => !((T == null ? void 0 : T.is_visible) ?? !0),
    [T == null ? void 0 : T.is_visible]
  ), w = pt({
    field: t,
    dependencies: a,
    subFormName: i,
    instanceIndex: v
  }), k = ae(
    () => Ct(t.validationRules ?? [], m),
    [t.validationRules, m]
  ), Z = ae(() => {
    const G = {};
    return k.forEach(({ ruleType: Q, ruleValue: ce, errorMessage: ye }) => {
      Q == "pattern" ? G[Q] = {
        value: new RegExp(ce),
        message: ye
      } : G[Q] = { value: ce, message: ye };
    }), (T == null ? void 0 : T.is_visible) ?? !0 ? G : {};
  }, [k, T == null ? void 0 : T.is_visible]), je = gn({
    name: t.fieldName,
    control: u.control,
    rules: {
      ...Z,
      deps: a
    },
    shouldUnregister: L
  });
  return f ? L ? /* @__PURE__ */ B.jsx(Je, {}, `${t.fieldId}_not_visible`) : /* @__PURE__ */ B.jsx(
    f,
    {
      formInstance: u,
      field: w,
      validations: w.validationRules,
      fieldControl: je,
      subFormName: i,
      subFormInstance: n,
      instanceIndex: v,
      ...T
    },
    `${t.fieldId}`
  ) : (console.warn(
    `Component not found for ${t.fieldName} component key: ${t.componentType}`
  ), /* @__PURE__ */ B.jsx(Je, {}, `fragment-${t.fieldId}`));
}, Yn = ({
  field: t,
  component: c,
  resolvedProps: d = {},
  subFormName: i,
  instanceIndex: v,
  subFormInstance: n,
  dependencies: a = []
}) => {
  const f = c, { setFormState: l } = be(), u = Ur(), [y, b] = Ar(
    t.componentProps ?? {}
  ), m = (T) => {
    const L = { ...y, ...T };
    JSON.stringify(L) !== JSON.stringify(y) && b(L);
  };
  _r(() => {
    const T = be.getState();
    T.propsSetters[t.fieldName] = m, l(T);
  }, [y]);
  const F = ae(
    () => ({
      ...(t == null ? void 0 : t.componentProps) ?? {},
      ...d,
      ...y ?? {}
    }),
    [d, y]
  ), U = ae(
    () => !((F == null ? void 0 : F.is_visible) ?? !0),
    [F == null ? void 0 : F.is_visible]
  ), R = pt({
    field: t,
    dependencies: a,
    subFormName: i,
    instanceIndex: v
  });
  return f ? U ? /* @__PURE__ */ B.jsx(Je, {}, `${t.fieldId}_not_visible`) : /* @__PURE__ */ B.jsx(
    f,
    {
      formInstance: u,
      field: R,
      subFormName: i,
      subFormInstance: n,
      instanceIndex: v,
      ...F
    },
    `${t.fieldId}`
  ) : (console.warn(
    "Component not found for component key: ",
    t.componentType
  ), /* @__PURE__ */ B.jsx(Je, {}, `fragment-${t.fieldId}`));
}, Kn = ({
  field: t,
  component: c,
  resolvedProps: d,
  componentMapper: i,
  propsMapper: v,
  subFormName: n,
  instanceIndex: a,
  subFormInstance: f,
  dependencies: l = []
}) => {
  const u = c, { setFormState: y } = be(), b = Ur(), [m, F] = Ar(
    (t == null ? void 0 : t.componentProps) ?? {}
  ), U = (w) => {
    const k = { ...m, ...w };
    JSON.stringify(k) !== JSON.stringify(m) && F(k);
  };
  _r(() => {
    const w = be.getState();
    w.propsSetters[t.fieldName] = U, y(w);
  }, [m]);
  const R = {
    ...(t == null ? void 0 : t.componentProps) ?? {},
    ...d,
    ...m ?? {}
  }, T = ae(
    () => !((R == null ? void 0 : R.is_visible) ?? !0),
    [R == null ? void 0 : R.is_visible]
  ), L = yn({
    name: t.fieldName,
    control: b.control,
    keyName: ot
  });
  return u ? T ? /* @__PURE__ */ B.jsx(Je, {}, `${t.fieldId}_not_visible`) : /* @__PURE__ */ B.jsx(
    u,
    {
      formInstance: b,
      field: t,
      subForm: L,
      ...R,
      children: L.fields.map((w, k) => /* @__PURE__ */ B.jsx(
        Je,
        {
          children: !!t.childFields && t.childFields.map((Z) => /* @__PURE__ */ B.jsx(
            dt,
            {
              field: Z,
              componentMapper: i,
              propsMapper: v,
              subFormName: t.fieldName,
              subFormInstance: L,
              instanceIndex: k
            },
            `${t.fieldName}.${k}.${Z.fieldName}-${w[ot]}`
          ))
        },
        `formgroup-${t.fieldName}-${w[ot]}`
      ))
    }
  ) : (console.warn(
    "Component not found for component key: ",
    t.componentType
  ), /* @__PURE__ */ B.jsx(Je, {}, `fragment-${t.fieldId}`));
}, Xn = ({
  field: t,
  component: c,
  componentMapper: d,
  propsMapper: i,
  resolvedProps: v = {},
  subFormName: n,
  instanceIndex: a,
  subFormInstance: f,
  dependencies: l = []
}) => {
  var w;
  const u = c, { setFormState: y } = be(), b = Ur(), [m, F] = Ar({}), U = (k) => {
    const Z = { ...m, ...k };
    JSON.stringify(Z) !== JSON.stringify(m) && F(Z);
  };
  _r(() => {
    const k = be.getState();
    k.propsSetters[t.fieldName] = U, y(k);
  }, [m]);
  const R = ae(
    () => ({
      ...(t == null ? void 0 : t.componentProps) ?? {},
      ...v,
      ...m ?? {}
    }),
    [v, m]
  ), T = ae(
    () => !((R == null ? void 0 : R.is_visible) ?? !0),
    [R == null ? void 0 : R.is_visible]
  ), L = pt({
    field: t,
    dependencies: l,
    subFormName: n,
    instanceIndex: a
  });
  return u ? T ? /* @__PURE__ */ B.jsx(Je, {}, `${t.fieldId}_not_visible`) : /* @__PURE__ */ B.jsx(
    u,
    {
      formInstance: b,
      field: L,
      subFormName: n,
      subFormInstance: f,
      instanceIndex: a,
      ...R,
      children: (w = t.childFields) == null ? void 0 : w.map((k) => /* @__PURE__ */ B.jsx(
        dt,
        {
          field: k,
          componentMapper: d,
          propsMapper: i,
          subFormName: n,
          subFormInstance: f,
          instanceIndex: a
        },
        `render-${t.fieldName}-${k.fieldId}`
      ))
    },
    `${t.fieldId}`
  ) : (console.warn(
    "Component not found for component key: ",
    t.componentType
  ), /* @__PURE__ */ B.jsx(Je, {}, `fragment-${t.fieldId}`));
}, dt = ({
  field: t,
  componentMapper: c,
  propsMapper: d,
  subFormName: i,
  instanceIndex: v,
  subFormInstance: n
}) => {
  var F, U, R;
  const a = c[t.componentType], { dependencies: f } = be(), l = ae(
    () => i && v !== void 0 ? `${i}.${v}.${t.fieldName}` : t.fieldName,
    [i, v, t.fieldName]
  ), u = ae(() => {
    if (!t.dynamicProps)
      return {};
    const T = {};
    for (const [L, w] of Object.entries(t.dynamicProps))
      d[w] && (T[L] = d[w]);
    return T;
  }, [t.dynamicProps, d]), y = ae(
    () => Array.from(f[l] || /* @__PURE__ */ new Set()),
    [f, l]
  ), b = ae(() => ({
    ...(t == null ? void 0 : t.componentProps) ?? {},
    ...u
  }), [t == null ? void 0 : t.componentProps, u]), m = ae(
    () => ({
      field: { ...t, fieldName: l },
      component: a,
      resolvedProps: b,
      subFormName: i,
      instanceIndex: v,
      subFormInstance: n,
      dependencies: y
    }),
    [
      t,
      l,
      a,
      b,
      i,
      v,
      n,
      y
    ]
  );
  return (F = t == null ? void 0 : t.fieldMetadata) != null && F.isSubForm ? /* @__PURE__ */ B.jsx(
    Kn,
    {
      ...m,
      componentMapper: c,
      propsMapper: d
    },
    `renderField_${t.fieldName}`
  ) : (U = t == null ? void 0 : t.childFields) != null && U.length ? /* @__PURE__ */ B.jsx(
    Xn,
    {
      ...m,
      componentMapper: c,
      propsMapper: d
    },
    `renderField_${t.fieldName}`
  ) : ((R = t == null ? void 0 : t.fieldMetadata) == null ? void 0 : R.isInput) === !1 ? /* @__PURE__ */ B.jsx(
    Yn,
    {
      ...m
    },
    `renderField_${t.fieldName}`
  ) : /* @__PURE__ */ B.jsx(zn, { ...m }, `renderField_${t.fieldName}`);
};
class Zn extends Mr.Component {
  constructor(c) {
    super(c), this.state = { error: null };
  }
  static getDerivedStateFromError(c) {
    return { error: c };
  }
  componentDidCatch(c, d) {
    var i, v;
    (v = (i = this.props).onError) == null || v.call(i, c, d);
  }
  render() {
    return this.state.error && this.props.fallbackRender ? this.props.fallbackRender({ error: this.state.error }) : this.state.error ? /* @__PURE__ */ B.jsx(B.Fragment, {}) : this.props.children;
  }
}
const to = ({
  schema: t,
  formInstance: c,
  componentMapper: d,
  propsMapper: i = {},
  callbacks: v = {},
  context: n = {},
  handleError: a = (l) => {
    console.error("FormBuilder Error:", l);
  },
  errorFallbackRender: f
}) => (An(t), /* @__PURE__ */ B.jsx(hn, { ...c, children: /* @__PURE__ */ B.jsx(Zn, { onError: a, fallbackRender: f, children: /* @__PURE__ */ B.jsx(lt.Provider, { value: n, children: /* @__PURE__ */ B.jsx(
  dt,
  {
    field: t,
    componentMapper: d,
    propsMapper: i
  }
) }) }) })), no = () => [It(lt)];
export {
  ot as DEFAULT_SUBFORM_ID,
  to as FormBuilder,
  no as useGlobalContext
};
